<template>
  <div :class="{ floating: floating }">
    <div class="internal">
      <el-row align="center">
        <el-col align="center" class="login-pane-title"> {{ title }} </el-col>
      </el-row>

      <img id="logo" alt="Logo" :src="darkLogo" />

      <el-steps v-if="!hideSteps" :active="currentStep" align-center>
        <el-step title="Registro"></el-step>
        <el-step title="Código"></el-step>
        <el-step title="Configuración"></el-step>
      </el-steps>

      <el-row class="my-4 mx-4">
        <el-col v-if="isStep(0)">
          <div class="text-center">
            <el-radio-group v-model="authMode" class="my-4 mx-auto">
              <el-radio-button label="PHONE">Teléfono</el-radio-button>
              <el-radio-button label="CODE">Código</el-radio-button>
            </el-radio-group>
          </div>

          <div v-if="isPhoneAuthMode">
            <el-form @submit.native.prevent="handleCheckPhone">
              <el-alert
                v-if="userFormValidationError"
                class="mb-3"
                description="Los datos introducidos no son válidos."
                show-icon
                title="Datos incorrectos"
                type="error"
              >
              </el-alert>
              <el-form-item label="Teléfono">
                <el-input
                  ref="phoneNumberInput"
                  v-model="$v.userForm.phoneNumber.$model"
                  :class="{ 'is-error': $v.userForm.phoneNumber.$error }"
                  placeholder="Número de teléfono"
                />
                <div
                  v-if="!$v.userForm.phoneNumber.required && $v.userForm.phoneNumber.$dirty"
                  class="el-form-item__error"
                >
                  Por favor, introduce un teléfono
                </div>
              </el-form-item>

              <el-form-item label="Nombre de usuario">
                <el-input
                  ref="userInput"
                  v-model="$v.userForm.username.$model"
                  :class="{ 'is-error': $v.userForm.username.$error }"
                  placeholder="Nombre de usuario"
                />
                <div
                  v-if="!$v.userForm.username.required && $v.userForm.username.$dirty"
                  class="el-form-item__error"
                >
                  Por favor, introduce un nombre de usuario
                </div>
              </el-form-item>

              <el-form-item label="Contraseña">
                <el-input
                  ref="passwordInput"
                  v-model="$v.userForm.password.$model"
                  :class="{ 'is-error': $v.userForm.password.$error }"
                  placeholder="Contraseña"
                  type="password"
                />
                <div
                  v-if="!$v.userForm.password.required && $v.userForm.password.$dirty"
                  class="el-form-item__error"
                >
                  Por favor, introduce una contraseña
                </div>
              </el-form-item>

              <div class="buttons">
                <el-button class="ml-auto" native-type="submit" type="primary">
                  Siguiente
                </el-button>
              </div>
            </el-form>
          </div>

          <div v-else>
            <el-form @submit.native.prevent="handleCheckCodeAuth">
              <el-alert
                v-if="codeFormValidationError"
                class="mb-3"
                description="El código indicado es inválido, inténtelo de nuevo."
                show-icon
                title="Código inválido"
                type="error"
              >
              </el-alert>
              <el-form-item label="Código" prop="code">
                <el-input
                  ref="userCodeInput"
                  v-model="$v.codeForm.code.$model"
                  :class="{ 'is-error': $v.codeForm.code.$error }"
                  placeholder="Código"
                />
                <div
                  v-if="!$v.codeForm.code.required && $v.codeForm.code.$dirty"
                  class="el-form-item__error"
                >
                  Por favor, introduce el código de acceso
                </div>
              </el-form-item>

              <div class="buttons">
                <el-button class="ml-auto" native-type="submit" type="primary">
                  Siguiente
                </el-button>
              </div>
            </el-form>
          </div>
        </el-col>

        <el-col v-if="isStep(1)">
          <el-form @submit.native.prevent="handleCheckCode">
            <p class="step-help">Introduce el código que te llegará mediante un SMS</p>

            <el-alert
              v-if="codeVerificationError"
              class="mb-3"
              description="El código proporcionado no es válido, inténtelo de nuevo."
              show-icon
              title="Código inválido"
              type="error"
            >
            </el-alert>

            <el-form-item label="Código de activación" prop="code">
              <el-input
                ref="codeInput"
                v-model="$v.formValidation.code.$model"
                :class="{ 'is-error': $v.formValidation.code.$error }"
                placeholder="Código"
              />
              <div
                v-if="!$v.formValidation.code.required && $v.formValidation.code.$dirty"
                class="el-form-item__error"
              >
                Por favor, introduce el código
              </div>
            </el-form-item>

            <div class="buttons">
              <el-button class="mr-auto" @click.prevent="handleGoBack"> Atrás </el-button>
              <el-button class="ml-auto" native-type="submit" type="primary"> Siguiente </el-button>
            </div>
          </el-form>
        </el-col>

        <el-col v-if="isStep(2)">
          <el-form label-position="top" @submit.native.prevent="handleConfiguration">
            <el-row>
              <el-col>
                <el-form-item label="Extensión telefónica" prop="number">
                  <div class="extensions-grid">
                    <el-radio
                      v-for="item in extensions"
                      :key="item.key"
                      v-model="formDesk.number"
                      :label="item.key"
                    >
                      {{ item.label }}
                    </el-radio>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item
                :class="{ 'is-error': $v.formDesk.sipPhone.$error }"
                label="SIP Phone"
                prop="sipPhone"
              >
                <el-radio-group v-model="formDesk.sipPhone">
                  <el-radio label="external">Externo</el-radio>
                  <el-radio label="internal">Interno</el-radio>
                </el-radio-group>
                <div
                  v-if="!$v.formDesk.sipPhone.required && $v.formDesk.sipPhone.$dirty"
                  class="el-form-item__error"
                >
                  Por favor, indica que tipo de SIP Phone utilizas.
                </div>
              </el-form-item>
            </el-row>
            <el-row>
              <el-col>
                <div class="buttons">
                  <el-button v-if="!hideBackButton" class="mr-auto" @click.prevent="handleGoBack">
                    Atrás
                  </el-button>
                  <el-button
                    v-if="showCancelButton"
                    class="mr-auto"
                    type="danger"
                    @click.prevent="handleCancel"
                  >
                    Cancelar
                  </el-button>
                  <el-button class="ml-auto" native-type="submit" type="success"> Hecho </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getTenantClient, getTenantClientWithAuthCode, setTenant } from "@/api/tenant";
import { AVAILABLE_EXTENSIONS } from "../../utils/constants";
import { required } from "vuelidate/lib/validators";
import flavours from "@/mixins/flavours";

export default {
  name: "OperatorSetup",

  mixins: [flavours],

  props: {
    initialStep: Number,
    callback: Function,
    floating: Boolean,
    hideBackButton: Boolean,
    hideSteps: Boolean,
    showCancelButton: Boolean,
    title: {
      type: String,
      default: "Registro para trabajadores de la central",
    },
  },

  data() {
    return {
      currentStep: 0,
      codeVerificationError: false,
      userFormValidationError: false,
      codeFormValidationError: false,
      extensions: [...AVAILABLE_EXTENSIONS],
      authMode: "PHONE",
      userForm: {
        phoneNumber: "",
        username: "",
        password: "",
      },
      codeForm: {
        code: "",
      },
      formValidation: {
        code: "",
      },
      rulesFormValidation: {
        code: [
          {
            required: true,
            message: "Por favor, introduce el código",
            trigger: "blur",
          },
        ],
      },
      formDesk: {
        number: 0,
        // name: "",
        sipPhone: "external",
      },
      rulesFormDesk: {
        number: [
          {
            required: true,
            message: "Por favor, selecciona un puesto",
            trigger: "change",
          },
        ],
      },
    };
  },

  validations() {
    if (this.isStep(0)) {
      if (this.isPhoneAuthMode) {
        return {
          userForm: {
            phoneNumber: {
              required,
            },
            username: {
              required,
            },
            password: {
              required,
            },
          },
        };
      } else {
        return {
          codeForm: {
            code: {
              required,
            },
          },
        };
      }
    } else if (this.isStep(1)) {
      return {
        formValidation: {
          code: {
            required,
          },
        },
      };
    } else if (this.isStep(2)) {
      return {
        formDesk: {
          number: {
            required,
          },
          sipPhone: {
            required,
          },
        },
      };
    }
  },

  computed: {
    ...mapGetters("clientUserRegisterData", ["deskName", "deskNumber", "deskSipPhone", "phoneExt"]),
    ...mapGetters("app", ["callCenter"]),

    isPhoneAuthMode() {
      return this.authMode === "PHONE";
    },
  },

  watch: {
    isPhoneAuthMode(v) {
      if (v) {
        this.focus("phoneNumberInput");
      } else {
        this.focus("userCodeInput");
      }
    },
  },

  created() {
    if (this.initialStep) {
      this.currentStep = this.initialStep;

      this.formDesk.number = this.deskNumber;
      this.formDesk.sipPhone = this.deskSipPhone;

      // This is to handle the case where the phoneExt is already set but number was not set properly
      if (!this.formDesk.number && this.phoneExt) {
        const phoneExt = this.phoneExt.slice(this.callCenter?.id?.toString().length);
        const sipPhone = phoneExt.slice(0, 1);
        const number = phoneExt.slice(1);
        this.formDesk.number = number || 0;
        this.formDesk.sipPhone = sipPhone === "0" ? "external" : "internal";
      }
    }
  },

  methods: {
    ...mapMutations("clientUserRegisterData", ["setDeskName", "setDeskNumber", "setDeskSipPhone"]),
    ...mapActions("clientUserRegisterData", ["createPhoneExt"]),

    focus(ref) {
      setTimeout(() => {
        if (this.$refs[ref]) {
          const item = this.$refs[ref].$el.querySelector("input");
          this.$nextTick(() => item.focus());
        }
      }, 250);
    },

    isStep(stepNumber) {
      return this.currentStep === stepNumber;
    },

    createLoader(text) {
      return this.$loading({
        target: ".el-card",
        text: text,
        spinner: "el-icon-loading",
      });
    },

    async validateUser() {
      this.userFormValidationError = false;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$message({
          type: "error",
          message: "Hay fallos en el formulario",
        });
        throw new Error("Validation error");
      } else {
        const { phoneNumber, username, password } = this.userForm;
        const baseUrl = await getTenantClient(phoneNumber, username, password);
        if (baseUrl !== null) {
          this.baseUrl = baseUrl;
          this.client = axios.create({
            baseUrl,
          });
          return true;
        } else {
          this.userFormValidationError = true;
          throw new Error("No backend");
        }
      }
    },

    validateUserWithCode() {
      this.codeFormValidationError = false;
      return new Promise((resolve, reject) => {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$message({
            type: "error",
            message: "Hay fallos en el formulario",
          });
          reject();
        } else {
          getTenantClientWithAuthCode(this.codeForm.code)
            .then((tenant) => {
              if (tenant.host !== null && tenant.token !== null) {
                this.baseUrl = tenant.host;
                this.client = axios.create({
                  baseUrl: tenant.host,
                });
                this.client.defaults.headers.common["Authorization"] = tenant.token;
                setTenant(tenant.host, tenant.token);
                return resolve(true);
              } else {
                this.codeFormValidationError = true;
                return reject();
              }
            })
            .catch((err) => {
              this.codeFormValidationError = true;
              return reject(err);
            });
        }
      });
    },

    validatePhoneCode() {
      this.codeVerificationError = false;
      return new Promise((resolve, reject) => {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$message({
            type: "error",
            message: "Hay fallos en el formulario",
          });
          reject();
        } else {
          axios
            .post(`https://${this.baseUrl}:7000/operators/equip/code`, null, {
              params: {
                phone: this.userForm.phoneNumber,
                code: this.formValidation.code,
              },
            })
            .then((r) => {
              this.client.defaults.headers.common["Authorization"] = r.data.token;
              setTenant(this.baseUrl, r.data.token);
              resolve(true);
            })
            .catch((error) => {
              this.codeVerificationError = true;
              console.error("error validating verification code: ", error);
              reject();
            });
        }
      });
    },

    handleGoBack() {
      this.currentStep--;
    },

    handleCancel() {
      this.$emit("cancel");
    },

    handleCheckPhone() {
      const loader = this.createLoader("Verificando teléfono...");
      this.validateUser()
        .then(() => {
          this.currentStep++;
          this.focus("codeInput");
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "No se ha podido validar el usuario",
          });
        })
        .finally(() => {
          loader.close();
        });
    },

    handleCheckCodeAuth() {
      const loader = this.createLoader("Verificando código...");
      this.validateUserWithCode()
        .then(() => {
          this.currentStep = 2;
          this.focus("deskNameInput");
        })
        .catch(() => {})
        .finally(() => {
          loader.close();
        });
    },

    handleCheckCode() {
      const loader = this.createLoader("Verificando código...");
      this.validatePhoneCode()
        .then(() => {
          this.currentStep++;
          this.focus("deskNameInput");
        })
        .catch(() => {})
        .finally(() => {
          loader.close();
        });
    },

    async handleConfiguration() {
      const loader = this.createLoader("Registrando puesto de trabajo...");
      this.onSetupDone();
      loader.close();
    },

    onSetupDone() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$message({
          type: "error",
          message: "Hay fallos en el formulario",
        });
        reject();
      } else {
        this.setDeskNumber(this.formDesk.number);
        this.setDeskSipPhone(this.formDesk.sipPhone);
        this.createPhoneExt();
        if (this.$listeners["close"]) {
          this.$emit("close");
          return true;
        } else {
          this.$router.push({
            path: "/login",
            query: { isFinishedSetup: true },
          });
          return false;
        }
      }
    },
  },

  mounted() {
    this.focus("phoneNumberInput");
  },
};
</script>

<style lang="scss" scoped>
.floating {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000000;

  .internal {
    position: fixed;
    max-width: 800px;
    background-color: white;
    z-index: 1000001;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }
}

.login-pane-title {
  font-size: 16px;
  font-weight: 500;
  margin: 25px 0 20px;
}

.step-help {
  text-align: center;
  font-size: 14px;
  color: $menuBg;
  margin: 15px 0 20px;
}

.buttons {
  padding-top: 5px;
  display: flex;
  justify-content: space-between;
}

.extensions-grid {
  margin: 15px 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px 0px;
}
</style>

<style>
.el-form-item__label::before {
  display: none;
}

img#logo {
  display: block;
  width: 8em;
  margin: 10px auto 40px;
}

.neositek img#logo {
  width: 8em !important;
}
</style>
